import React, {Component, PropTypes} from 'react';

import BasicLayout from 'layouts/Basic';

import CandidatesDataGrid from 'components/candidates/DataGrid.jsx';
import CandidatesIndepth from 'components/candidates/Indepth.jsx';
import CandidatesControls from 'components/candidates/Controls.jsx';

class Page extends Component {
  constructor(props) {
    super(props);

    this.state = {selected: []};
  }
  select = (selected) => {
    this.setState({selected: Object.keys(selected)});
  }
  render() {
    const props = this.props;
    return (
      <BasicLayout
        hero={props.selected && <CandidatesIndepth {...props} />}
        main={<CandidatesDataGrid {...props} select={this.select} />}
        aside={<CandidatesControls {...props} selected={this.state.selected} />}
      />
    );
  }
};

import {resource} from 'utils/resourcerizer';
import {connect} from 'react-redux';
import {updateMatchesWith} from 'actions';
import {CANDIDATES_NS} from 'constants/index';

const mstp = state => ({
  isMatching: state.matches.isMatching,
});

const mdtp = dispatch => ({
  updateMatches: (candidates) => dispatch(updateMatchesWith({candidateIds: candidates})),
});

Page.Container = resource(CANDIDATES_NS)(connect(mstp,mdtp)(Page));
export default Page;



// WEBPACK FOOTER //
// ./src/components/candidates/Page.jsx